// Delegated handlers survive Turbolinks visits without accumulating listeners.
const closeMenu = (restoreFocus = false) => {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.getElementById('main-nav');
  if (!toggle || !nav) return;
  nav.classList.remove('is-open');
  nav.querySelectorAll('.nav-dropdown[open]').forEach(menu => menu.removeAttribute('open'));
  toggle.setAttribute('aria-expanded', 'false');
  toggle.setAttribute('aria-label', 'Open navigation');
  if (restoreFocus) toggle.focus();
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.mobile-menu-toggle');
  if (toggle) {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    document.getElementById('main-nav').classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
  } else if (event.target.closest('.main-nav a') || !event.target.closest('.site-header')) {
    closeMenu();
  }
});
document.addEventListener('toggle', (event) => {
  if (!event.target.matches('.nav-dropdown') || !event.target.open) return;
  document.querySelectorAll('.nav-dropdown[open]').forEach(menu => {
    if (menu !== event.target) menu.removeAttribute('open');
  });
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && document.querySelector('.main-nav.is-open')) closeMenu(true);
});
document.addEventListener('focusin', (event) => {
  if (!event.target.closest('.site-header')) closeMenu();
});
document.addEventListener('turbolinks:before-cache', () => closeMenu());
window.matchMedia('(min-width: 1200px)').addEventListener('change', () => closeMenu());
